module.exports = __webpack_public_path__ + "media/test-management.f8795ba32a46a957d03745ab3eff756c.svg";